<template>
    <div class="menu-wrapper">
        <template v-for="item in routes" v-if="!item.hidden&&item.children">
            <router-link v-if="!item.meta && !item.children[0].children" :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
                <el-menu-item  :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
                    <!--<svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>-->
                    <i :class="item.children[0].meta.icon" style="margin-left: -4px" v-if="item.children[0].meta&&item.children[0].meta.icon"></i>
                    <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
                </el-menu-item>
            </router-link>
            <el-submenu v-else-if="!item.hidden && hasAuth(item.children)" :index="item.name||item.path" :key="item.name">
                <template slot="title">
                    <!--<svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>-->
                    <i :class="item.meta.icon" style="margin-left: -4px" v-if="item.meta&&item.meta.icon"></i>
                    <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
                </template>
                <template v-for="child in item.children" v-if="!child.hidden">
                    <sidebar-item :is-nest="true" class="nest-menu" v-if="!child.meta.insideURL && child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>
                    <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
                        <el-menu-item :index="item.path+'/'+child.path" v-if="newAuth(child)">
                            <!--<svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>-->
                            <span v-if="child.meta && child.meta.title" slot="title">{{child.meta.title}}</span>
                        </el-menu-item>
                    </router-link>
                </template>
            </el-submenu>
        </template>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import config from '@/Config'
    import auth from "../../../../auths"
    import auths from "../../../../auths";
    export default {
        name: 'SidebarItem',
        data(){
            return{
            }
        },
        props: {
            routes: {
                type: Array
            },
            isNest: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            newAuth(route) {
                let roleCode = localStorage.getItem('roleCode');
                if ( roleCode=='MERCHANT') {
                    return auth[roleCode].indexOf(route.auth) > -1
                }else {
                    return true
                }
            },
            // 判断登录者是否没有某个一级下的所有二级
            hasAuth(children) {
                for (let i = 0; i < children.length; i++) {
                    if (this.isAuth(children[i].auth) && !children[i].hidden) return true;
                }
                return false;
            },
            hasOneShowingChildren(children) {
                const showingChildren = children.filter(item => {
                    return !item.hidden
                });
                if (showingChildren.length === 1) {
                    return true
                }
                return false
            },
        },
        created(){
            request.get(`/manager/platform/dicts/permission/menu`).then(({result})=>{
                let showConfig = {}
                result.forEach(element => {
                    showConfig[element.label] = element.value === "ACTIVATE" ? false : true
                });
                this.routes.forEach(element => {
                    switch(element.path){
                        case "/operation" :
                            element.children.forEach(elementChild => {
                                if (elementChild.name === "area") {
                                    elementChild.hidden = showConfig.PERMISSION_AREA_AGENT
                                }
                            });
                            break;
                        case "/userManage" :
                            element.children.forEach(elementChild => {
                                if (elementChild.name === "staffList") {
                                    elementChild.hidden = showConfig.PERMISSION_STAFF
                                }
                            });
                            break;
                        case "/conv" :
                            element.hidden = showConfig.PERMISSION_CONVERSION
                            break;
                        case "/system" :
                            element.children.forEach(elementChild => {
                                if (elementChild.name === "orderConfig") {
                                    elementChild.hidden = showConfig.PERMISSION_PROFIT_DATA && config.hideOrderConfig
                                }
                            });
                            break;
                        case "/productStorage" :
                            element.children.forEach(elementChild => {
                                if (elementChild.name === "virtualCode") {
                                    elementChild.hidden = showConfig.PERMISSION_VIRTUAL_CODE
                                }
                            });
                            break;
                    }
                });
                this.$forceUpdate()
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue